import styled from 'styled-components';

import { PRIMARY, ORANGE_SECONDARY, GRAY } from 'constants/colors';

const BalanceBudgetStyles = styled.div`
  display: flex;
  position: relative;

  .side {
    width: 50%;
    box-sizing: border-box;
  }

  .left-side {
    padding-right: 30px;
  }
  .right-side {
    padding-left: 30px;
  }

  .divider {
    position: absolute;
    left: 50%;
    top: 0;
    height: 100%;
    border-left: 1px solid ${PRIMARY};
  }

  h3 {
    margin-bottom: 20px;
  }

  .salary-system-card {
    border: 2px solid ${ORANGE_SECONDARY};
  }

  .total-budget {
    padding: 15px 20px;
    background-color: aliceblue;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    h2 {
      margin-bottom: 0;
    }

    big {
      font-size: 30px;
    }

    .bar {
      height: 30px;
      background-color: ${GRAY};
      position: relative;
      margin-bottom: 10px;

      .out-of {
        position: absolute;
        right: 0;
        bottom: 100%;
      }

      .max {
        position: absolute;
        right: 0;
        top: 100%;
        font-size: small;
      }
    }

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }

    .sdb {
      background-color: ${PRIMARY};

      &.preview {
        background-color: ${PRIMARY};
        background: repeating-linear-gradient(
          -45deg,
          ${GRAY},
          ${GRAY} 5px,
          ${PRIMARY} 5px,
          ${PRIMARY} 25px
        );
      }
    }

    .system {
      background-color: ${ORANGE_SECONDARY};

      &.preview {
        background-color: ${ORANGE_SECONDARY};
        background: repeating-linear-gradient(
          -45deg,
          ${GRAY},
          ${GRAY} 5px,
          ${ORANGE_SECONDARY} 5px,
          ${ORANGE_SECONDARY} 25px
        );
      }
    }
  }

  .logs {
    h3 {
      margin-bottom: 10px;
    }
  }
`;

export default BalanceBudgetStyles;
